export const APPLICATIONFORMPDF = 'APPLICATIONFORMPDF';
export const APPLICATIONFORMDETAILS = 'APPLICATIONFORMDETAILS';
export const APPLICATIONFORMIMAGES = 'APPLICATIONFORMIMAGES';
export const APPLICATIONFORMPRINTLOCATION = 'APPLICATIONFORMPRINTLOCATION';
